import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { Box, Grid, IconButton } from '@mui/material';
import clsx from 'clsx';
import React, { useEffect, useMemo, useState } from 'react';

import Image from 'commons/Image';
import ImageCustom from 'commons/ImageCustom';
import { TESTID } from 'configs/Constant';

import ArtworkImageLightBox from './ArtworkImageLightBox';
import useStyles from './styles';

const ArtworkImage = ({ artwork }) => {
  const [viewImage, setViewImage] = useState();
  const [isLightBoxOpen, setIsLightBoxOpen] = useState(false);
  const [lightBoxIndex, setLightBoxIndex] = useState(0);

  const classes = useStyles();

  const listImages = useMemo(() => {
    return artwork?.images || [];
  }, [artwork?.images]);

  const handleClickImage = (image, index) => {
    setViewImage(image);
    setLightBoxIndex(index);
  };

  const handleOpenLightBox = () => {
    setIsLightBoxOpen(true);
  };

  const handleCloseLightBox = () => {
    setIsLightBoxOpen(false);
  };

  useEffect(() => {
    setViewImage(listImages[0]);
    setLightBoxIndex(0);
  }, [listImages]);

  return (
    <Box className={classes.wrapArtworkImage}>
      <Box className={classes.mainImageContainer}>
        <Image
          src={viewImage}
          imageStyle={classes.viewImage}
          testid={TESTID.VIEW_IMAGE}
          onClick={handleOpenLightBox}
        />
        <IconButton
          className={classes.zoomButton}
          onClick={handleOpenLightBox}
          aria-label="zoom image"
        >
          <ZoomInIcon />
        </IconButton>
      </Box>

      <div className={classes.listImage}>
        <Grid
          container
          spacing={2}
        >
          {listImages.map((item, index) => (
            <Grid
              item
              lg
              key={item}
            >
              <div
                onClick={() => handleClickImage(item, index)}
                testid={TESTID.WRAP_IMAGE}
              >
                <ImageCustom
                  src={item}
                  imageStyle={clsx(classes.imageItem, {
                    [classes.active]: viewImage === item,
                  })}
                  iconLoadingStyle={classes.iconLoadingStyle}
                />
              </div>
            </Grid>
          ))}
        </Grid>
      </div>

      <ArtworkImageLightBox
        open={isLightBoxOpen}
        onClose={handleCloseLightBox}
        images={listImages}
        initialIndex={lightBoxIndex}
      />
    </Box>
  );
};

export default ArtworkImage;
